// extracted by mini-css-extract-plugin
export default {"container":"container-riyi9Olj","spin":"spin-zCG54EaT","storybookSpinner":"storybookSpinner-ZhmwuJZa"};